export const CELL_DETAIL_DROPDOWN_CLASSNAME =
    'rounded-xl border border-gray-200 bg-white shadow-md max-w-[min(100vw-2rem,44rem)] min-w-[min(100vw-2rem,22rem)] p-0';

export const CELL_DETAIL_ARROW_CLASSNAME =
    '!border-[var(--mantine-color-gray-3)]';

export const CELL_DETAIL_TRIGGER_CLASSNAME =
    'box-border rounded-lg border-2 border-solid border-gray-300 bg-white px-4 py-0 h-16 w-full max-w-[18rem] min-w-0 shrink-0 text-left shadow-none transition-colors [outline:none] hover:bg-gray-50/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary';

export const THIN_BORDER_CELL_DETAIL_TRIGGER_CLASSNAME =
    'box-border rounded-lg border border-solid border-gray-300 bg-white px-4 py-0 h-16 w-full max-w-[18rem] min-w-0 shrink-0 text-left shadow-none transition-colors [outline:none] hover:bg-gray-50/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary';

export const REQUEST_HISTORY_CELL_DETAIL_TRIGGER_CLASSNAME =
    THIN_BORDER_CELL_DETAIL_TRIGGER_CLASSNAME;

export const PRODUCT_SALES_CELL_DETAIL_DROPDOWN_CLASSNAME =
    'w-[min(100vw-2rem,42rem)] min-w-[min(100vw-2rem,36rem)] max-w-[min(100vw-2rem,42rem)]';
